import * as React from 'react';
import {Image} from 'react-native';

import convertImageSource from '../../../helpers/convertImageSource';

import logoWhiteUri from '../../../../assets/images/logo_white.png';

interface Props {
  width?: number;
  height?: number;
}

const LogoWhite: React.FunctionComponent<Props> = props => {
  const {width, height} = props;
  return (
    <Image
      source={convertImageSource(logoWhiteUri)}
      style={{width: width || 155, height: height || 24}}
    />
  );
};

export default React.memo(LogoWhite);
